document.addEventListener('octane.quiz.completed', () => {
  updateProducts();
});


function updateProducts() {
  let productUrls = new Array;
  document.querySelectorAll('.oct-quiz-result-item__title').forEach(title => {
    let link = title.getAttribute('href');
    productUrls?.push(link);
    title?.closest('.oct-quiz-products__item')?.querySelector('.oct-quiz-result-actions-wrapper')?.classList.add('hidden');
    console.log(link, "link")
    getProduct(link, title);
  });
}

async function getProduct(url, title) {
  try {
    const response = await fetch(url + '?section_id=product-information', {
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch product page: HTTP error ${response.status}`);
    }

    const responseText = await response.text();
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const section = title.closest('.oct-quiz-products__item').querySelector('.oct-quiz-result-actions-wrapper');
    const productSubscription = html.querySelector('.subscription-options-block');

    const productForm = html.querySelector('.buy-buttons-block');
    section.innerHTML = productSubscription?.innerHTML + productForm?.innerHTML;

    if (!section) return;

    const oldScript = section.querySelector('script[src]');

    if (!oldScript) return;
    if (!oldScript.src) return;

    const newScript = document.createElement('script');
    newScript.type = 'module';
    newScript.src = oldScript.src + '?v=' + Date.now();

    oldScript.remove();
    section.appendChild(newScript);
    section.querySelector('.subscription-options__title')?.classList.add('hidden');
    section.querySelector('quantity-selector-component')?.classList.add('hidden');
    section.classList.remove('hidden');
  } catch (error) {
    if (error.name === 'AbortError') {
    } else {
      throw error;
    }
  } finally {
  }
}
